<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M34 16H30V6C30 4.9 29.1 4 28 4H20C18.9 4 18 4.9 18 6V16H14C11.8 16 10 17.8 10 20V38C10 40.2 11.8 42 14 42C14 43.1 14.9 44 16 44C17.1 44 18 43.1 18 42H30C30 43.1 30.9 44 32 44C33.1 44 34 43.1 34 42C36.2 42 38 40.2 38 38V20C38 17.8 36.2 16 34 16ZM21 7H27V16H21V7ZM34 38H14V20H34V38Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
